<template>
  <div class="deliveryOptions">
    <p class="fs-20">Delivery options</p>
    <div class="d-flex">
      <div :class="activeItemClass(1)" class="item" @click="setActive(1)">
        <div class="img-wrap">
          <img alt="" src="/assets/images/builds/boxes-ic.jpg"/>
        </div>
        <div class="text-wrap">
          <p class="title">Receive orders individually</p>
          <div class="text">
            <p>
              <span class="color-black">May 2021 -</span>
              <span class="color-gray">Europe / UK / United States / Canada</span>
            </p>
            <p>
              <span class="color-black">March 2021 - April 2021 -</span>
              <span class="color-gray">Other countries</span>
            </p>
          </div>
          <button
            :class="togglerClass"
            class="btn btn-link light"
            type="button"
            @click.prevent="toggle"
          >
            Learn more
            <svg
              class="arr"
              fill="none"
              height="12"
              viewBox="0 0 14 9"
              width="12"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 0.999999L7 7L13 1"
                stroke="black"
                stroke-width="2"
              />
            </svg>
          </button>

          <div v-if="show">
            <div class="text">
              <p>
                <strong>Front Light Lezyne Classic Drive 700XL</strong>
              </p>
              <p>
                <span class="color-black">May 2021 -</span>
                <span class="color-gray">Europe / UK / United States / Canada</span>
              </p>
              <p>
                <span class="color-black">March 2021 - April 2021 -</span>
                <span class="color-gray">Other countries</span>
              </p>
            </div>

            <div class="text">
              <p><strong>Siryon Diode «Pure Oil»</strong></p>
              <p>
                <span class="color-black">May 2021 -</span>
                <span class="color-gray">Europe / UK / United States / Canada</span>
              </p>
              <p>
                <span class="color-black">March 2021 - April 2021 -</span>
                <span class="color-gray">Other countries</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div :class="activeItemClass(2)" class="item" @click="setActive(2)">
        <div class="img-wrap">
          <img alt="" src="/assets/images/builds/box-ic.jpg"/>
        </div>
        <div class="text-wrap">
          <p class="title">Get orders together</p>
          <div class="text">
            <p>
              <span class="color-black">May 2021 - </span>
              <span class="color-gray">Europe / UK / United States / Canada</span>
            </p>
            <p>
              <span class="color-black">April 2021 - </span>
              <span class="color-gray">Other countries</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <hr/>
  </div>
</template>

<script>
export default {
  name: "DeliveryOptions",
  data() {
    return {
      show: false,
      active: 1
    }
  },
  computed: {
    togglerClass() {
      return {
        open: this.show
      }
    },
  },
  methods: {
    setActive(number) {
      this.active = number
    },
    activeItemClass(number) {
      return {
        active: this.active === number
      }
    },
    toggle() {
      this.show = !this.show
    },
  }
}
</script>
